<template>
  <div>
    <v-flex style="height: 100%; max-width: 350px" v-if="isMobile()">
      <v-carousel
        cycle
        hide-delimiter-background
        show-arrows-on-hover
        background-size:
        cover
        style="width: 100%; max-height: 200px"
      >
        <v-carousel-item eager v-for="(item, i) in items" :key="i">
          <v-img :src="item.src"></v-img>
        </v-carousel-item>
      </v-carousel>
    </v-flex>

    <v-flex v-if="!isMobile()">
      <v-carousel
        cycle
        hide-delimiter-background
        show-arrows-on-hover
        background-size:
        cover
      >
        <v-carousel-item eager v-for="(item, i) in items" :key="i">
          <v-img :src="item.src"></v-img>
        </v-carousel-item>
      </v-carousel>
    </v-flex>
  </div>
  <!--<div max-height="650" max-width="1200">
    <carousel :per-page="1" autoplay>
      <slide>
        <v-img :src="items[0]"></v-img>
      </slide>
      <slide>
        <v-img :src="items[1]"></v-img>
      </slide>
    </carousel>
  </div>-->
</template>

<script>
//import { Carousel, Slide } from "vue-carousel";

export default {
  //components: {
  //  Carousel,
  //  Slide,
  // },

  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "200px";
        case "sm":
          return "200px";
        case "md":
          return "200px";
        case "lg":
          return "200px";
        case "xl":
          return "200px";
      }
      return "650px";
    },

    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "90px";
        case "sm":
          return "90px";
        case "md":
          return "90px";
        case "lg":
          return "90px";
        case "xl":
          return "90px";
      }
      return "650px";
    },
  },

  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  data() {
    return {
      items: [
        {
          src: require("../assets/msfGame1New.png"),
        },
        {
          src: require("../assets/spaceGame1.png"),
        },
        {
          src: require("../assets/socksGame1new.png"),
        },
        //{
        //  src: require("../assets/stoneGame1new.png"),
        //},
        {
          src: require("../assets/senryuGame1.png"),
        },
        //{
        //  src: require("../assets/officeGame1new.png"),
        //},
      ],
    };
  },
};
</script>

<style scoped>
.v-carousel {
  max-height: imageHeight !important;
}
</style>